import { createTheme } from "@mui/material/styles";
import { useReservationResources } from "../../pageComponents/reservationPage/hooks/useReservationResources";

const r = useReservationResources();

export const muiTheme = createTheme({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "transparent",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
          },
          "&:active": {
            backgroundColor: "transparent",
          },
          "& .MuiTouchRipple-root": {
            opacity: 0,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          minHeight: 48,
          borderRadius: 8,
          backgroundColor: "#fff",
          alignItems: "center",
        },
        input: {
          padding: "12px 12px",
          "&.MuiInputBase-inputAdornedStart": {
            padding: "12px 12px",
            height: "unset",
          },
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        noOptionsText: r.NoData,
      },
      styleOverrides: {
        inputRoot: {
          padding: 0,
          minHeight: 48,
          alignItems: "center",

          "& .MuiAutocomplete-input": {
            padding: "12px 12px",
          },
        },

        noOptions: {
          fontFamily: "pf_highway_sans_pro_lightRg",
          fontSize: "14px",
          fontWeight: "400",
          color: "#646567",
          padding: "12px 16px",
        },

        popupIndicator: {
          color: "#0D0C1C",
        },

        root: {
          "& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator":
            {
              "&:hover, &.Mui-focusVisible, &:active": {
                backgroundColor: "transparent",
              },
              "& .MuiTouchRipple-root": {
                opacity: 0,
              },
            },
        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          // remove grey background on hover
          "&:hover": {
            backgroundColor: "transparent",
          },

          // remove background on click / active
          "&:active": {
            backgroundColor: "transparent",
          },

          // remove background when focused via keyboard
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
          },

          // optional: kill ripple animation completely
          "& .MuiTouchRipple-root": {
            opacity: 0,
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        asterisk: {
          display: "none",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "&&": {
            padding: 0,
          },
        },
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          "&.MuiRadioGroup-root": {
            gap: 16,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          // removes grey divider
          "&::before": {
            display: "none",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        expandIconWrapper: {
          color: "#0D0C1C",
        },
      },
    },
  },
});
